export default __webpack_public_path__ + "static/media/webTop.5d19b97c.png";